import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '/auth.js';
import Home from '../views/HomePage.vue';
import Login from '../views/LoginPage.vue';
import Account from '../views/AccountPage.vue';
import AccountPayment from '../views/AccountPayment.vue';
import AccountSettings from '../views/AccountSettings.vue';
import PasswordReset from '@/views/PasswordReset.vue';
import AllMembers from '../views/MembersPage.vue';
import RankingNational from '../views/RankingNationalPage.vue';
import RankingClubs from '../views/RankingClubsPage.vue';
import RankingRegional from '../views/RankingRegionalPage.vue';
import RankingWorld from '../views/RankingWorldPage.vue';


import NotFound from "@/views/NotFound.vue";



import Event from '../views/EventPage.vue';
import EventCreate from '../views/EventCreate.vue';
import EventSettings from '../views/EventSettings.vue';
import EventEntry from '../views/EntryPage.vue';


import AllClub from '../views/AllClubPage.vue';
import Club from '../views/ClubPage.vue';
import Dashboard from '../views/DashboardPage.vue';
import RadioPanel from '../views/RadioControlPage.vue';
import OchecklistStore from '../views/OchecklistStoragePage.vue';

import Help from '../views/HelpPage.vue';
import Exporty from '../views/ExportPage.vue';
// import Api from '../views/ApiPage.vue';
import Version from '../views/VersionPage.vue';
import ResultsPage from '@/views/ResultsPage.vue';




const routes = [
  {path: '/', name: 'HomePage', component: Home},
  {path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound},


  {path: '/login', name: 'LoginPage', component: Login},
  {path: '/reset_hesla/:uid/:token', name: 'PasswordReset', component: PasswordReset, props: true },
  {path: '/ucet/:id/', name: 'AccountPage', component: Account},
  {path: '/finance/', name: 'AccountPayment', component: AccountPayment, meta: { requiresAuth: true }},
  {path: '/nastaveni/', name: 'AccountSettings', component: AccountSettings, meta: { requiresAuth: true }},
  {path: '/clenove/', name: 'AllMembers', component: AllMembers, meta: { requiresAuth: true }},
  {path: '/vysledky/', name: 'ResultsPage', component: ResultsPage},
  {path: '/vysledky/:year/:raceId', name: 'ResultsPageRace', component: ResultsPage},
  {path: '/vysledky/:year/:raceId/speaker', name: 'ResultsPageSpeaker', component: ResultsPage},
  {path: '/ranking/national/:year', name: 'RankingNational', component: RankingNational },
  {path: '/ranking/clubs/:year', name: 'RankingClubs', component: RankingClubs },
  {path: '/ranking/:region/:year', name: 'RankingRegional', component: RankingRegional },
  {path: '/ranking/world/:year/:month/:category', name: 'RankingWorld', component: RankingWorld },


 



  {path: '/soutez/vytvorit', name: 'EventCreate', component: EventCreate, meta: { requiresAuth: true }},
  {path: '/soutez/:id', name: 'EventPage', component: Event},
  {path: '/soutez/:id/nastaveni', name: 'EventSettings', component: EventSettings, meta: { requiresAuth: true }},
  {path: '/soutez/:id/prihlaska/', name: 'EventEntry', component: EventEntry},

  {path: '/ochecklist/', name: 'OchecklistStore', component: OchecklistStore},



  
  {path: '/oddil', name: 'AllClubPage', component: AllClub},
  {path: '/oddil/:id', name: 'ClubPage', component: Club, meta: { requiresAuth: true }},
  {path: '/dashboard', name: 'DashboardPage', component: Dashboard, meta: { requiresAuth: true, requiresManager: true }},
  {path: '/radio', name: 'RadioPanel', component: RadioPanel, meta: { requiresAuth: true, requiresRadioControlManager: true }},   // anyPerms: ['organizer','radio_control_manager']  }},


  {path: '/napoveda', name: 'HelpPage', component: Help},
  {path: '/export', name: 'ExportPage', component: Exporty, meta: { requiresAuth: true }},
  // {path: '/api', name: 'ApiPage', component: Api, meta: { requiresAuth: true }},
  {path: '/verze', name: 'VersionPage', component: Version},




];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Pokud cílová stránka je HelpPage, nebudeme měnit pozici scrollování
    if (to.name === 'HelpPage') {
      return;
    }
    // Pokud se navigace odehrává ve stejné stránce (například při změně záložky)
    // můžeme vrátit prázdný objekt, aby se scroll nezměnil.
    if (to.name === from.name) {
      return {};
    }
    // Pro všechny ostatní stránky se bude scrollovat nahoru
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0, behavior: 'smooth' };
    }
  },
});

// Před načtením se zkontrolují položky, které vyžadují autorizaci
router.beforeEach((to, from, next) => {
  const auth = useAuthStore();

  // 1) auth check
  if (to.matched.some(r => r.meta.requiresAuth) && !auth.isLoggedIn) {
    return next({ name: 'LoginPage', query: { redirect: to.fullPath } });
  }

  // 2) permission check
  if (to.matched.some(r => r.meta.requiresManager)) {
    if (!auth.hasPermissionFor('manager')) return next({ name: 'NotFound' });
  }

  if (to.matched.some(r => r.meta.requiresOrganizer)) {
    if (!auth.hasPermissionFor('organizer')) return next({ name: 'NotFound' });
  }

  if (to.matched.some(r => r.meta.requiresRadioControlManager)) {
    if (!auth.hasPermissionFor('radio_control_manager')) return next({ name: 'NotFound' });
  }

  // Kontrola oprávnění naráz - buď organizátor nebo radio_control_manager
  const needsOrgOrRCM = to.matched.some(r =>
    r.meta.requiresOrganizer || r.meta.requiresRadioControlManager
  );

  if (needsOrgOrRCM) {
    const ok = auth.hasPermissionFor('organizer') ||
              auth.hasPermissionFor('radio_control_manager');
    if (!ok) return next({ name: 'NotFound' });
}

  next();
});


export default router;